import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/semantic-platform/data-governance")({
  component: Outlet,
});
